import type { TStatus } from "@/app/_module/types/filter-types";
import { Status } from "@/app/_module/types/filter-types";

export const getStatusDisplayName = (status?: TStatus): string => {
  switch (status) {
    case Status.SCHEDULED:
      return "Scheduled";
    case Status.RESCHEDULED:
      return "Rescheduled";
    case Status.PENDING:
      return "Pending";
    case Status.CONFIRMED:
      return "Confirmed";
    case Status.COMPLETED:
      return "Completed";
    case Status.CANCELLED:
      return "Cancelled";
    case Status.NO_SHOW:
      return "No Show";
    case Status.OVERDUE:
      return "Overdue";
    default:
      // Format unknown statuses by converting underscores to spaces and capitalizing
      if (!status) return "Pending";
      return status
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
  }
};
